import React, { useCallback, useRef } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { useCheckPermission } from 'cityads-v3/hooks/permissions'

export default function LinkToPayments({ children, ...props }: LinkProps): JSX.Element {
  const checkPermission = useCheckPermission()

  return checkPermission('show_v3_payments') ?
    (
      <Link {...props} to="/publisher/payments">{children}</Link>
    )
    :
    (
      <a {...props} href="/webmaster/office/payments">{children}</a>
    )
}
